import { render, staticRenderFns } from "./ProblemDetail.vue?vue&type=template&id=661317cc&scoped=true"
import script from "./ProblemDetail.vue?vue&type=script&lang=js"
export * from "./ProblemDetail.vue?vue&type=script&lang=js"
import style0 from "./ProblemDetail.vue?vue&type=style&index=0&id=661317cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661317cc",
  null
  
)

export default component.exports